import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectTriggerOverview } from "../../CommonComponents/CommonProjectTriggerViews";
export const ProjectTriggerDeploymentTargetNewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().deploymentTargetTriggerNew,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectTriggerOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
